import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Recibes un email con acceso inmediato a todos los archivos PDF. En menos de 5 minutos tienes todo en tu dispositivo, sin importar en qué país estés.'
}, {
  question: '2 — ¿Sirve para profesores particulares o solo para estudios establecidos?',
  answer: 'Sirve para ambos. Tanto si enseñas en tu casa, en un estudio propio, en una academia o de forma online.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'Los PDFs están optimizados para lectura e impresión. Puedes usarlos libremente en tu práctica docente.'
}, {
  question: '4 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos en ambas opciones, siempre y sin costo extra.'
}, {
  question: '5 — ¿Sirve si soy profesor nuevo con poca experiencia enseñando?',
  answer: 'Perfectamente. El Tomo 1 está diseñado específicamente para profesores que recién comienzan, con secuencias paso a paso.'
}, {
  question: '6 — ¿Sirve para alumnos de todas las edades?',
  answer: 'Sí. Tienes desde secuencias para adultos jóvenes hasta el Tomo 5 completo dedicado a adultos mayores y poblaciones especiales.'
}, {
  question: '7 — ¿Qué pasa si tengo alumnos de distintos niveles en la misma clase?',
  answer: 'Cada tomo incluye criterios de adaptación por nivel. Puedes tomar la misma secuencia y ajustarla en minutos para distintos grupos.'
}, {
  question: '8 — ¿Qué diferencia tiene el MegaPack con otros materiales de yoga?',
  answer: 'Es el único sistema que combina pedagogía completa (técnica + progresión + meditación) con gestión de negocio (marketing + legal + precios) en un solo pack.'
}, {
  question: '9 — ¿Por qué elegir el MegaPack + Estudio Pro Elite y no el estándar?',
  answer: 'Si quieres solo el contenido técnico, el MegaPack estándar es excelente. Si además quieres llenar tus horarios, subir tus precios y tener un sistema de retención, el Pro Elite es la versión que lo hace posible.'
}, {
  question: '10 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días con devolución del 100%, sin preguntas. Menos del 1% de los compradores la solicita.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-99">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-100">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#B87AFF] bg-[#0d0a1a]' : 'border-[#B87AFF]/20 bg-black'}`} data-id="element-101">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-102">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-103">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#B87AFF] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-104">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-105">
                  <div className="h-px bg-[#B87AFF]/20 mb-4" data-id="element-106" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-107">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}